/* eslint-disable sort-imports */
import $ from 'jquery';
import {newsLetterSubscriptionEvent, signUpEvent} from '../../vendor/dynamicyield/dynamicyield';
import {onDOMContentLoaded} from '../../dom/events';
import {parseQueryString} from '../../smartpak/url';
import {verifyAddress} from '../../smartpak/qas';
import '../../../jsscripts/jquery/jquery.password_strength.js';
import mobileAlert from '../myaccount/manageMobileAlerts';
import {tooltipProxy as tooltip} from '../../smartpak/tooltipproxy';
import customerProfile from '../myaccount/customerProfile';
import { signup as reCaptchaSignUp } from '../../vendor/recaptcha/recaptcha.js';

function isBarnPopulated() {
    var barn = !!$('#BusinessName').val(),
        addr = !!$('#Address1').val(),
        city = !!$('#City').val(),
        zip = !!$('#PostalCode').val(),
        state = !!$('#StateId').val();

    if (barn && addr && city && zip && state) {
        $('#BarnManagerInfo').show();
        $('#BarnFields').addClass('barnFieldsOpen');
    }
}

function qasValidate(form, callback) {
    if ($('#UpsAddressCorrection', form).is(':checked') && callback) {
        callback();
    } else {
        verifyAddress(form, callback);
    }
}

function handleSubmit(event) {
    event.preventDefault();

    const $form = $(event.target);
    const $submitButton = $form.find('[type="submit"]');

    if (!$form.valid()) {
        return;
    }

    $submitButton.prop('disabled', true);

    const submit = () => {
        $form.off('submit', handleSubmit);
        $form.trigger('submit');
        $form.on('submit', handleSubmit);
        $submitButton.prop('disabled', false);
        fireDyEvents();
    };

    qasValidate($form, async function () {
        const token = await reCaptchaSignUp();

        $form.find('#Token').val(token);
        submit();
    });
}

function fireDyEvents() {
    var email = $('#EmailAddress').val();
    signUpEvent(email);

    if ($('#SendMeHorseAndRiderPromotionsAndShoppingSpree').is(':checked')) {
        newsLetterSubscriptionEvent(email);
    }
}

function addPasswordFields() {
    const createPwd = parseQueryString(location.search);
    const $validation = document.querySelector('.validation-summary-errors');

    if ((createPwd && createPwd.create === 'true') || ($validation && /password/gi.test($validation.textContent))) {
        $('.passwordFields').removeClass('jsHide');
    }
}

function bindEvents() {
    tooltip($('.barnCheckTooltip'), {
        trigger: 'hover click',
        content: $('#barnShippingInfo').html(),
        placement: 'bottom',
        width: 220
    });

    $('#findBarnLink').on('click', function (event) {
        event.preventDefault();

        var findBarnLink = $(event.target),
            barnSearchUrl = findBarnLink.attr('href'),
            form = $('#registerme');
        form.off('submit');
        form.attr('action', barnSearchUrl);
        form.trigger('submit');
    });

    $('#registerme').on('submit', handleSubmit);

    $('#IsBarn').on('click', function (e) {
        var checkbox = $(e.target),
            isBarn = checkbox.prop('checked');
        $('#BarnManagerInfo').toggle(isBarn);
        isBarn ? $('#BarnFields').addClass('barnFieldsOpen') : $('#BarnFields').removeClass('barnFieldsOpen');
    });

    tooltip($('#EmailAddress'), {
        trigger: 'focus',
        width: 220
    });

    $('#IsMobilePhoneNumber').on('click', function (e) {
        var $phone = $('#PhoneNumber'),
            phoneVal = $phone.val(),
            $sms = $('#SmsPhoneNumber'),
            isChecked = $(e.target).prop('checked');

        if (phoneVal.length && isChecked) {
            $sms.val(phoneVal);
        } else if (!isChecked && $sms.val() === phoneVal) {
            $sms.val('');
        }
    });

    $('#Password').passStrength();
}

function convertErrorStringToHTML() {
    [...document.querySelectorAll('.validation-summary-errors li')].forEach($item => $item.innerHTML = $item.innerText);
}

onDOMContentLoaded(() => {
    var names = ['Customer Owns or Leases', 'Primary Style of Riding', 'Barn Professional'];
    convertErrorStringToHTML();
    bindEvents();
    isBarnPopulated();
    addPasswordFields();
    mobileAlert._init();
    customerProfile.init(names);
});
